import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

import { ApiProvider } from "@providers/common/api.service";
import { preferencesEndpoints, userPreferencesUrl, } from "@common/constants";
import { FiltroConsultaVinInfo, GuardarPreferenciasConsultaVinResult } from "@interfaces/consult-fields-preferences/consultFieldsPreferences.interface";


@Injectable({
  providedIn: 'root'
})
export class UserPreferencesService {
  private api = inject(ApiProvider);

  private universoConsultaVin$: Observable<FiltroConsultaVinInfo[]> | null = null;

  getUniversoConsultaVin(): Observable<FiltroConsultaVinInfo[]> {
    if (!this.universoConsultaVin$) {
      const endpoint = preferencesEndpoints.getFiltrosConsultaVin;

      this.universoConsultaVin$ = (this.api.post(endpoint, {}, userPreferencesUrl) as Observable<FiltroConsultaVinInfo[]>)
        .pipe(shareReplay(1));
    }

    return this.universoConsultaVin$;
  }

  setPreferenciasUsuarioConsultaVin(filtrosSeleccionados: string[]): Observable<GuardarPreferenciasConsultaVinResult> {

    const endpoint = preferencesEndpoints.setConsultaVin;

    return this.api.post(endpoint, {
    camposSeleccionados: filtrosSeleccionados,
    }, userPreferencesUrl) as Observable<GuardarPreferenciasConsultaVinResult>;
  }

}
